import {TradeIdeaRiskRecord} from "./TradeIdeaRecord";

export class TradeIdeaRiskViewModel {

    private constructor(public readonly currentLots: number,
                        private readonly incrementAmount: number,
                        public readonly lotsStepSize: number,
                        public readonly maxRisk: number,
                        private readonly riskRecord: TradeIdeaRiskRecord) {
    }

    public get currentRisk(): number {
        return this.currentLots * this.riskRecord.risk;
    }

    public get currentPayoff(): number {
        return this.currentLots * this.riskRecord.payoff;
    }

    public get minimumLots(): number {
        return this.lotsStepSize;
    }

    public get maximumLots(): number {
        const max = this.maxRisk / this.riskRecord.risk;
        return Math.floor(max);
    }

    public updateLots(lots: number): TradeIdeaRiskViewModel {
        return new TradeIdeaRiskViewModel(Math.min(lots, this.maximumLots),
                                          this.incrementAmount,
                                          this.lotsStepSize,
                                          this.maxRisk,
                                          this.riskRecord);
    }

    public static create(riskRecord: TradeIdeaRiskRecord, incrementAmount: number, maxRisk: number) {
        const lotStepSize = Math.ceil(incrementAmount / riskRecord.risk);
        return new TradeIdeaRiskViewModel(lotStepSize, incrementAmount, lotStepSize, maxRisk, riskRecord);
    }
}
